<template>
  <div class="container">
    <div class="row" style="margin-bottom:5rem;">
      <div id="carouselExampleIndicators" class="carousel slide" data-bs-ride="carousel">
        <div class="carousel-indicators">
          <button v-for="(ban, i) in baner" v-bind:key="ban" type="button" data-bs-target="#carouselExampleIndicators"
            :data-bs-slide-to="i" v-bind:class="(i == 0) ? 'active' : ''" aria-current="true"></button>
          <!-- <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="1"></button>
          <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="2"></button> -->
        </div>
        <div class="carousel-inner">

          <div v-for="(ban, i) in baner" v-bind:key="ban"
            v-bind:class="(i == 0) ? 'carousel-item active' : 'carousel-item'">
            <a href="#">
              <img :src="ISBASE_URL + '/api/banner/' + ban.id + '/photo'" alt="" class="d-block w-100">
            </a>
          </div>

          <!-- <div class="carousel-item active">
              <a href="#">
                <img src="@/assets/slider/Banner-1.png" class="d-block w-100">
              </a>
            </div> -->
          <!-- <div class="carousel-item">
            <a href="#">
              <img src="@/assets/slider/Banner-2.png" class="d-block w-100">
            </a>
          </div> -->
        </div>
        <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators"
          data-bs-slide="prev">
          <span class="carousel-control-prev-icon" aria-hidden="true"></span>
          <span class="visually-hidden">Previous</span>
        </button>
        <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators"
          data-bs-slide="next">
          <span class="carousel-control-next-icon" aria-hidden="true"></span>
          <span class="visually-hidden">Next</span>
        </button>
      </div>
    </div>


    <div class="row" style="margin-bottom:5rem;">
      <div class="col-sx-12 col-sm-4" style="margin-bottom:0.5rem;">
        <div class="card bg-primary text-white">
          <div class="card-body">
            <h5 class="card-title text-center" style="font-size:1.5rem;">{{ tenagakerja }}</h5>
            <p class="text-center">Jumlah Tenaga Kerja
              <br>
              <span style="font-size:0.8rem;">yang terdaftar di Kota Batam tahun {{ dateyear }}</span>
            </p>
          </div>
        </div>
      </div>
      <div class="col-sx-12 col-sm-4" style="margin-bottom:0.5rem;">
        <div class="card bg-success text-white">
          <div class="card-body">
            <h5 class="card-title text-center" style="font-size:1.5rem;">{{ badausaha }}</h5>
            <p class="text-center">Jumlah Badan Usaha
              <br>
              <span style="font-size:0.8rem;">yang terdaftar di Kota Batam tahun {{ dateyear }}</span>
            </p>
          </div>
        </div>
      </div>
      <div class="col-sx-12 col-sm-4" style="margin-bottom:0.5rem;">
        <div class="card bg-danger text-white">
          <div class="card-body">
            <h5 class="card-title text-center" style="font-size:1.5rem;">{{ proyek }}</h5>
            <p class="text-center">Jumlah Proyek
              <br>
              <span style="font-size:0.8rem;">yang terdaftar di Kota Batam tahun {{ dateyear }}</span>
            </p>
          </div>
        </div>
      </div>
    </div>

    <div class="row" style="margin-bottom:2rem;">
      <div class="col-sx-12 col-md-6" style="padding:1rem;">
        <router-link :to="{ name: 'InfoTukang' }" class="text-dark" style="text-decoration: none;">
          <img src="@/assets/Banner-Sijakon-Tukang.png" class="imggambar" style="width:100%;height:100%;">
        </router-link>
      </div>
      <div class="col-sx-12 col-md-6" style="padding:1rem;">
        <router-link :to="{ name: 'BadanUsaha' }" class="text-dark" style="text-decoration: none;">
          <img src="@/assets/Banner-Sijakon-BdanUsaha.png" class="imggambar" style="width:100%;height:100%;">
        </router-link>
      </div>
    </div>

    <div class="row" style="margin-bottom:2rem;">
      <div class="col-sx-12 col-md-6" style="margin-bottom:0.5rem;">
        <router-link :to="{ name: 'InfoPeralatan' }" class="text-dark" style="text-decoration: none;">
          <img src="@/assets/Banner-Sijakon-Peralatan.png" class="imggambar" style="width:100%;height:100%;">
        </router-link>
      </div>
      <div class="col-sx-12 col-md-6" style="margin-bottom:0.5rem;">
        <router-link :to="{ name: 'InfoMaterial' }" class="text-dark" style="text-decoration: none;">
          <img src="@/assets/Banner-Sijakon-Material.png" class="imggambar" style="width:100%;height:100%;">
        </router-link>
      </div>
    </div>

    <div class="row" style="margin-bottom:5rem;">
      <div class="col-12" style="margin-bottom:0.5rem;">
        <router-link :to="{ name: 'InfoProyek' }" class="text-dark" style="text-decoration: none;">
          <img src="@/assets/Banner-Sijakon-Proyek-Landscape.png" class="imggambar" style="width:100%;height:100%;">
        </router-link>
      </div>
    </div>

    <div class="row" style="margin-bottom:5rem;">
      <div class="col-xs-12">
        <h5 class="card-title">POPULASI TENAGA KERJA KONSTRUKSI</h5>
        <p style="font-size:0.8rem;">Data pertumbuhan Tenaga Kerja Konstruksi di Kota Batam</p>
      </div>
      <div class="col-xs-12">
        <column-chart :data="chartData"></column-chart>
      </div>
    </div>
  </div>
  <div style="padding:0.5rem;margin:5rem 0;">
    <div class="container">
      <div v-for="(kad) in kadis" v-bind:key="kad">
        <div class="row">
          <div class="col-xs-12 col-md-3 text-center">
            <!-- <img src="@/assets/kadis.png" class="img-fluid img-thumbnail" style="width:15rem;border-radius: 50%;"> -->
            <img :src="ISBASE_URL + '/api/kadis/' + kad.id + '/photo'" class="img-fluid img-thumbnail"
              style="width:15rem;border-radius: 50%;">
          </div>
          <div class="col-xs-12 col-md-9" style="padding-top:2.5rem;">
            <p style="font-size:1.4rem;" class="text-center">{{ kad.nama_kadis }} | {{ kad.jabatan }}</p>
            <p style="font-size:1.8rem;" class="text-center">{{ kad.pesan }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="container">
    <div class="shadow-sm p-3 mb-5 bg-body rounded" style="margin-bottom:5rem;">
      <div class="row">
        <div class="col-xs-12 col-md-8">
          <h4>Ayo unduh Sijakon</h4>
          <p>Hanya dengan mengunduh aplikasi androidnya sekarang juga!<br>
            Anda bisa mencari Tukang sesuai keahlihan dan kebutuhan yang anda inginkan, Disini tukang<br>
            bersertifikat dan mendapatkan pengawasan khusus dari Pemerintah
          </p>
        </div>
        <div class="col-xs-12 col-md-3">
          <div class="row">
            <div class="col-xs-12 text-center d-sm-block d-md-none">
              <a href="https://play.google.com/store/apps/details?id=id.go.batam.sijakon1" target="_blank"><img
                  src="@/assets/play.png" style="width:10rem;"></a>
            </div>
            <div class="col-xs-12 d-none d-md-block" style="text-align:right;margin-top:2.5rem;">
              <a href="https://play.google.com/store/apps/details?id=id.go.batam.sijakon1" target="_blank"><img
                  src="@/assets/play.png" style="width:15rem;"></a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.imggambar {
  /* border-radius: 5%; */
}
</style>

<script>
import * as CONFIG from '@/config.js'
export default {
  data() {
    return {
      nama: "",
      jabatan: "",
      pesan: "",
      tenagakerja: 0,
      badausaha: 0,
      proyek: 0,
      datastatistik: {},
      chartData: {},
      dateyear: '2021',
      baner: [],
      kadis: [],
      ISBASE_URL: CONFIG.BASE_URL
    }
  },
  created() {
    // this.chartData.push(['Work', 32], ['Play', 567],['sleep', 300])
    let d = new Date()
    this.dateyear = d.getFullYear()
  },
  mounted() {
    window.scrollTo(0, 0)

    const baseurl = CONFIG.BASE_URL + '/api/landing-dashboard'
    this.axios.get(baseurl).then((response) => {
      this.tenagakerja = response.data.metadata.messages.tenaga_kerja
      this.badausaha = response.data.metadata.messages.badan_usaha
      this.proyek = response.data.metadata.messages.proyek
      // console.log(response.data.metadata.messages.baner)
      this.baner = response.data.metadata.messages.baner
      this.kadis = response.data.metadata.messages.kadis
      const datamasuk = response.data.metadata.messages.kecamatan
      let loadjson = ''
      datamasuk.forEach(function (item) {
        if (loadjson != '') { loadjson += ',' }
        loadjson += '"' + item.nama_kecamatan + '":' + item.list_tenaga_kerja_count
      })
      loadjson = '{' + loadjson + '}'
      this.chartData = JSON.parse(loadjson)
    })
    document.title = 'Home'
    this.nama = "Suhar, ST"
    this.jabatan = "Kepala Dinas Cipta Karya dan Tata Ruang Kota Batam"
    this.pesan = '"Kehadiran SIJAKON akan menjawab keinginan masyarakat terhadap kebutuhan akan Jasa Konstruksi yang tersertifikasi dan terpercaya"'
  },
}
</script>